module.exports = __webpack_public_path__ + "img/24-min.7d4efd0b.jpg";